/**
 * Chave de idempotência de operações financeiras.
 *
 * A chave anterior era derivada do conteúdo (`cr-<id>-<data>-<valor>`): duas
 * baixas legítimas de R$ 100 no mesmo título e no mesmo dia nasciam com a MESMA
 * chave, e a segunda era descartada pelo servidor com mensagem de sucesso — o
 * título ficava com R$ 100 recebidos em vez de R$ 200.
 *
 * Agora cada nova operação recebe um identificador próprio. A chave só é
 * reaproveitada nas tentativas da mesma operação (reenvio depois de falha de
 * rede, em que não se sabe se o servidor gravou).
 */
export function novaChaveOperacao(prefixo) {
    const aleatorio = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    return `${prefixo}-${aleatorio}`;
}

/**
 * A resposta foi conclusiva? Erro sem `response` é falha de rede/timeout: o
 * servidor pode ter processado, então a chave precisa ser preservada para a
 * próxima tentativa. Erro COM resposta significa que o servidor recusou e não
 * gravou nada — a próxima tentativa é uma operação nova.
 */
export function respostaConclusiva(error) {
    return Boolean(error && error.response);
}
